<h4 class="m-0 text-lg font-bold text-default">
  {{ 'Balances' | translate }}
</h4>
<p class="flex items-center gap-1 text-sm font-semibold text-support">
  {{ startDate() | localeDate: 'compact' }} -
  {{ endDate() | localeDate: 'compact' }}
  @if (endContractDate()) {
    <sb-icon
      [name]="'question-circle'"
      [sbTooltip]="
        'Contract ends on [endContractDate]' | translate: { endContractDate: endContractDate() | localeDate: 'long' }
      "
      [sbTooltipPlacement]="'top'"
      [sbTooltipMaxWidth]="'18rem'"
    />
  }
</p>
@if (loading) {
  <sb-loading-state class="py-2xl" />
} @else if (!balances?.length) {
  <sb-empty-state class="py-2xl" icon="calendar-slash" [description]="'No time off balances' | translate" />
} @else {
  <div class="flex flex-col gap-2">
    @for (balance of balances; track $index) {
      <time-off-balance
        [balance]="balance"
        [year]="year()"
        [employee]="employee"
        [balanceExpiries]="balanceExpiriesMap[balance.timeOffBalanceId]"
        [isActive]="balanceStatusMap[balance.timeOffBalanceId]"
        (toggled)="onBalanceToggle(balance)"
      >
      </time-off-balance>
    }
  </div>
}
